import { OnInit, Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Center } from "../../model/center";
import { SectorFilter } from "../../model/sector-filter";
import { CompanyFilter } from "../../model/company-filter";
import { LoginWizardService } from "../../services/wizard/login/login.wizard.service";

@Component({
  selector: 'app-login-sector-component',
  templateUrl: './login-sector.component.html',
  styleUrls: ['./login-sector.component.css']
})

export class LoginSectorComponent implements OnInit {
  public loginForm: FormGroup;
  public loading = false;
  public centers: Center[];
  public sectors: SectorFilter[];
  public companies: CompanyFilter[];
  public sector: SectorFilter;

  constructor(private formBuilder: FormBuilder,
      private loginWizardService: LoginWizardService) { }

  ngOnInit(): void {

    this.centers = this.loginWizardService.getAllCenters();
    this.companies = this.loginWizardService.getAllCompanies();
    let center: Center;

    if (this.centers != null && this.centers.length > 0) {
      center = this.centers[0];
    }

    this.loginForm = this.formBuilder.group({
      center: [center, Validators.required],
      sector: [null, Validators.required],
      companies: [this.companies, Validators.required],
    });

    if (center != null) {
      this.centerChange();
    }
  }

  get f() { return this.loginForm.controls; }

  centerChange() {

    this.loginForm.patchValue({
      sector: null
    });

    if (this.loginForm.value.center != null) {
      this.sectors = this.loginWizardService
        .getSectors(this.loginForm.value.center.Id);

      if (this.sectors.length > 0) {
        this.loginForm.patchValue({
          sector: this.sectors[0]
        });
      }

    }
  }

  login() {

    this.loading = true;
    if (this.loginForm.invalid) {
      return;
    }

    this.loginWizardService.setSectorCenterAndCompanies
      ( this.loginForm.value.sector,
        this.loginForm.value.center,
        this.loginForm.value.companies);

    this.loading = false;
  }
}
